import request from "../axios";

// 账号密码登录
export function loginFn(data) {
  return request({
    url: "/auth/login",
    method: "post",
    data,
  });
}

// 角色选择
export function roleIdentify(data) {
  return request({
    url: "/auth/select-roles",
    method: "post",
    data,
  });
}

// 退出登录登录
export function logoutFn(params) {
  return request({
    url: "/auth/logout",
    method: "post",
    params,
  });
}

// 获取权限数据
export function getAuth(params) {
  return request({
    url: "/auth/route",
    method: "get",
    params,
  });
}

// 修改个人信息
export function updateUserInfo(data) {
  return request({
    url: "/admin/user/center/edit-info",
    method: "put",
    data,
  });
}

// 修改个人密码
export function updateUserPassword(data) {
  return request({
    url: "/admin/user/center/edit-password",
    method: "put",
    data,
  });
}

// 查询积分变更记录
export function getUserIntegral(params) {
  return request({
    url: "/admin/user/center/integral",
    method: "get",
    params,
  });
}

// 发送验证码
export function sendSMSCode(params) {
  return request({
    url: "/auth/sms/send",
    method: "post",
    params,
  });
}

// 手机验证码登录
export function smsLoginFn(data) {
  return request({
    url: "/auth/sms/login",
    method: "post",
    data,
  });
}

// 短信验证码找回密码提交
export function smsRetrieve(data) {
  return request({
    url: "/auth/sms/retrieve",
    method: "post",
    data,
  });
}
